module.exports = __webpack_public_path__ + "static/media/stanthony.61f77dc9.webp";